import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shield, ArrowLeft } from "lucide-react";
import { usePlatformAuth } from "@/lib/auth";
import { extractErr } from "@/lib/api";
import LoginPasswordInput, { passwordFromForm } from "@/components/LoginPasswordInput";

export default function SuperLogin() {
  const nav = useNavigate();
  const { login } = usePlatformAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const password = passwordFromForm(e.currentTarget);
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome, admin");
      nav("/super-admin");
    } catch (err) { toast.error(extractErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-sm text-slate-500 hover:text-white mb-8" data-testid="super-back"><ArrowLeft className="w-4 h-4" /> Home</Link>
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-lg bg-indigo-500/20 border border-indigo-400/40 flex items-center justify-center"><Shield className="w-4 h-4 text-indigo-300" /></div>
          <span className="font-display font-extrabold text-lg">Platform admin</span>
        </div>
        <h1 className="font-display text-2xl font-bold">Restricted access</h1>
        <p className="text-slate-500 text-sm mt-1">Sign in with a platform admin account.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label className="text-slate-300">Email</Label><Input type="email" name="email" autoComplete="username" data-testid="super-email" className="bg-slate-900 border-slate-800 text-white mt-1" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div><Label className="text-slate-300">Password</Label><LoginPasswordInput testId="super-password" className="bg-slate-900 border-slate-800 text-white mt-1" /></div>
          <Button type="submit" disabled={loading} data-testid="super-submit" className="w-full h-11 bg-indigo-500 hover:bg-indigo-600 rounded-full">{loading ? "Signing in…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
